var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.session)?_c('session-registration',{attrs:{"session":_vm.session,"profile":_vm.profile,"theme":null}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }